/**
 * Расчёт множителя и выплаты
 * Формула: мультипликативная — текущий_множитель *= выпавший_X
 */

export function applyMultiplier(current: number, segmentValue: number): number {
  return current * segmentValue;
}

export function computePayout(bet: number, multiplier: number): number {
  return Math.round(bet * multiplier * 100) / 100;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

/** Ease-out для разгона колец */
export function easeOutCubic(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}

/** Ease-in для остановки колец */
export function easeInCubic(t: number): number {
  return t * t * t;
}

/** Нормализация угла в [0, 2*PI) */
export function normalizeAngle(rad: number): number {
  const twoPi = Math.PI * 2;
  let a = rad % twoPi;
  if (a < 0) a += twoPi;
  return a;
}
